/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseTemplateRequest } from '../models/api-response-template-request';
import { deleteMetaTemplateRequest } from '../fn/meta-template-request-api/delete-meta-template-request';
import { DeleteMetaTemplateRequest$Params } from '../fn/meta-template-request-api/delete-meta-template-request';
import { sendTemplateRequest } from '../fn/meta-template-request-api/send-template-request';
import { SendTemplateRequest$Params } from '../fn/meta-template-request-api/send-template-request';
import { updateMetaTemplateCategory } from '../fn/meta-template-request-api/update-meta-template-category';
import { UpdateMetaTemplateCategory$Params } from '../fn/meta-template-request-api/update-meta-template-category';
import { updateMetaTemplateContent } from '../fn/meta-template-request-api/update-meta-template-content';
import { UpdateMetaTemplateContent$Params } from '../fn/meta-template-request-api/update-meta-template-content';

@Injectable({ providedIn: 'root' })
export class MetaTemplateRequestApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateMetaTemplateContent()` */
  static readonly UpdateMetaTemplateContentPath = '/v1/api/ui/meta-request-template/{reference}/content';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMetaTemplateContent()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMetaTemplateContent$Response(params: UpdateMetaTemplateContent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateRequest>> {
    return updateMetaTemplateContent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMetaTemplateContent$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMetaTemplateContent(params: UpdateMetaTemplateContent$Params, context?: HttpContext): Observable<ApiResponseTemplateRequest> {
    return this.updateMetaTemplateContent$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateRequest>): ApiResponseTemplateRequest => r.body)
    );
  }

  /** Path part for operation `updateMetaTemplateCategory()` */
  static readonly UpdateMetaTemplateCategoryPath = '/v1/api/ui/meta-request-template/{reference}/category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMetaTemplateCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMetaTemplateCategory$Response(params: UpdateMetaTemplateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateRequest>> {
    return updateMetaTemplateCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMetaTemplateCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMetaTemplateCategory(params: UpdateMetaTemplateCategory$Params, context?: HttpContext): Observable<ApiResponseTemplateRequest> {
    return this.updateMetaTemplateCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateRequest>): ApiResponseTemplateRequest => r.body)
    );
  }

  /** Path part for operation `sendTemplateRequest()` */
  static readonly SendTemplateRequestPath = '/v1/api/ui/meta-request-template/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendTemplateRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendTemplateRequest$Response(params: SendTemplateRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateRequest>> {
    return sendTemplateRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendTemplateRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendTemplateRequest(params: SendTemplateRequest$Params, context?: HttpContext): Observable<ApiResponseTemplateRequest> {
    return this.sendTemplateRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateRequest>): ApiResponseTemplateRequest => r.body)
    );
  }

  /** Path part for operation `deleteMetaTemplateRequest()` */
  static readonly DeleteMetaTemplateRequestPath = '/v1/api/ui/meta-request-template/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMetaTemplateRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMetaTemplateRequest$Response(params: DeleteMetaTemplateRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMetaTemplateRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMetaTemplateRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMetaTemplateRequest(params: DeleteMetaTemplateRequest$Params, context?: HttpContext): Observable<void> {
    return this.deleteMetaTemplateRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
